import { HttpInterceptorFn } from '@angular/common/http';
import { AuthService } from '../../auth/auth.service';
import { inject } from '@angular/core';
import { UserDto } from '@oracychampions/api-interfaces';

export const headerInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);

  const accessToken = auth.auth$.getValue()?.accessToken;
  const school = (auth.auth$.getValue()?.user as UserDto)?.schoolId;

  if (isExternalUrl(req.url)) {
    return next(req);
  }

  if (accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  if (school) {
    req = req.clone({
      setHeaders: {
        School: school,
      },
    });
  }

  return next(req);
};

function isExternalUrl(url: string) {
  const domain = (url: string) => url.replace('http://', '').replace('https://', '').split('/')[0];
  return domain(location.href) !== domain(url) && domain(url) !== domain('api.oracychampions.com');
}
